import {Job} from "./job";

export class JobMapper {

  public static map(data: any): Job {
    let job: Job = new Job();

    job.id = 'default'; // TODO: data.id; if multiple jobs available
    job.jobId = data.job_id;
    job.jobName = 'default'; // TODO: data.id; if multiple jobs available
    job.name = data.name;
    job.type = data.options && data.options.type && data.options.type.length ? data.options.type : '';
    job.destination = data.options && data.options.destination && data.options.destination.length ? data.options.destination[0] : '';
    job.lastRunDate = data.last_run ? new Date(data.last_run * 1000) : null;
    job.nextRunDate = data.next_run ? new Date(data.next_run * 1000) : null;
    job.schedule = !!(data.options && data.options.schedule === 'tenweb');
    job.cron_expression = data.options && data.options.schedule && data.options.schedule === 'tenweb' ? data.options.cron_expression : '';
    job.types = data.options.type;
    return job;
  }

}
